import type { GridSortModel } from "@mui/x-data-grid-premium";
import type { SortConfiguration } from "../../../../../../../../api/types/svTypes.ts";
import { Ordering } from "../../../../../../../../api/types/svTypes.ts";

export const getSortingModel = (sortingFields: SortConfiguration[], fieldsIds: string[]): GridSortModel =>
  sortingFields
    .map((sf) => {
      const field = fieldsIds.find((fieldId) => fieldId === sf.id);
      if (!field) {
        return undefined;
      }
      return { field, sort: sf.ordering === Ordering.Descending ? "desc" : "asc" };
    })
    .filter((sf) => sf !== undefined) as GridSortModel;
